<div class="row">
  <div class="col-xxl-6 col-xl-6 col-lg-6 col-md-6">
    <cdk-virtual-scroll-viewport (scroll)="onTableScroll($event)" class="list" itemSize="35">
      <table [dataSource]="this" [multiTemplateDataRows]="true" class="table" mat-table>
        <ng-container matColumnDef="timestamp">
          <th *matHeaderCellDef class="tableBg" mat-header-cell> Time</th>
          <td *matCellDef="let element" mat-cell> {{element.timestamp | date: 'dd.MM.yy HH:mm'}} </td>
        </ng-container>

        <ng-container matColumnDef="position">
          <th *matHeaderCellDef class="tableBg" mat-header-cell> Position</th>
          <td *matCellDef="let element" mat-cell> {{element.coordinate.coordinates[1]}},
            {{element.coordinate.coordinates[0]}} </td>
        </ng-container>

        <tr *matHeaderRowDef="displayedColumns; sticky: true" mat-header-row></tr>

        <!-- cdkVirtualScrollViewport uses transform: translateY to correct for all elements that are removed.
We will use a plcaholder row in the table instead because the translate causes problems with the sticky header -->
        <tr *matRowDef="let row; let index = index; columns: []; when: placeholderWhen" [style.height.px]="placeholderHeight"
            mat-row></tr>

        <tr *matRowDef="let row; columns: displayedColumns" mat-row></tr>
      </table>
      <div class="spinnerWrapper">
        <ng-container *ngIf="loading">
          <sb-icon [animationOptions]="{autoplay: true, loop:true}" class="loadingSpinnerSVG" icon="loadingBlockAnimation"
                   style="font-size: 2rem"></sb-icon>
          <span>{{'lang.globals.pleaseWait' | translate}}</span>
        </ng-container>
      </div>
    </cdk-virtual-scroll-viewport>
  </div>
  <div class="col-xxl-6 col-xl-6 col-lg-6 col-md-6">
    <sb-polygon-edit-map [centerPoint]="center" [initialZoom]="7" [lineStrings]="lineStrings" [mapheight]="400"
                         [nominatim]="false" [points]="points" [readOnly]="true" [roundedCorners]="true"
                         [zoomControl]="false"></sb-polygon-edit-map>
  </div>
</div>
